import { getDestination } from '../../../../utils';
import { withErrorBoundary } from '../../../components';
import { type FeaturesSectionLink } from '../FeaturesSectionModule';

import { CardTitle, CardWrapper, Gradient, StyledChevron, StyledImage, TitleWrapper } from './Styled';

const TopCard = ({ item }: { item: FeaturesSectionLink }) => {
  const { title, id, image, cardLink } = item;

  return (
    <CardWrapper key={id} to={cardLink?.externalUrl ?? getDestination(cardLink?.internalEntry)}>
      <TitleWrapper>
        <CardTitle>{title}</CardTitle>
        <StyledChevron />
      </TitleWrapper>
      <StyledImage
        alt={image?.altText ? image.altText : image.title}
        image={image.asset?.gatsbyImageData}
        objectFit="cover"
      />
      <Gradient />
    </CardWrapper>
  );
};

export default withErrorBoundary(TopCard, { componentName: 'FeaturesSectionModule/TopCard' });
